import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Box, useMediaQuery, useTheme } from '@mui/material';
import HomeScreen from './screen/HomeScreen';
import ProductList from './screen/ProductList';
import ProductDetail from './screen/ProductDetail';
import CartScreen from './screen/CartScreen';
import CheckoutScreen from './screen/CheckoutScreen';
import OrderListScreen from './screen/OrderListScreen';
import ProtectedRoute from './components/ProtectedRoute';
import AuthProvider from './screen/admin/AuthProvider';
import AdminApp from './screen/admin/AdminApp';
import AboutUs from './screen/AboutUs';
import ContactUs from './screen/ContactUs';
import './App.css';
import ResetPassword from './components/ResetPassword';
import UserProfile from './screen/UserProfile';

function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Router>
      <Box
        sx={{
          minHeight: '100vh',
          // Mobile-first responsive padding
          px: {
            xs: 1,    // 8px on mobile
            sm: 2,    // 16px on small tablets
            md: 3,    // 24px on tablets
            lg: 4,    // 32px on desktop
            xl: 6     // 48px on large screens
          },
          // Add safe area support for mobile devices with notches
          pt: {
            xs: 'max(16px, env(safe-area-inset-top))',
            sm: 2
          },
          pb: {
            xs: 'max(16px, env(safe-area-inset-bottom))',
            sm: 2
          },
          // Ensure proper background on mobile
          backgroundColor: 'background.primary',
          // Prevent horizontal scrolling on mobile
          overflowX: 'hidden'
        }}
      >
        <Container
          maxWidth="xl"
          disableGutters={isMobile} // Remove default gutters on mobile
          sx={{
            // More granular padding control
            px: {
              xs: 0,    // No additional padding on mobile (handled by Box above)
              sm: 1,    // 8px on small screens
              md: 2,    // 16px on medium screens
              lg: 3     // 24px on large screens
            },
            // Ensure full width utilization on mobile
            width: { xs: '100%', sm: 'auto' },
            // Smooth transitions for responsive changes
            transition: 'padding 0.3s ease-in-out'
          }}
        >
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/store" element={<ProductList language={localStorage.getItem('lang')} />} />
            <Route path="/store/:id" element={<ProductDetail language={localStorage.getItem('lang')} />} />
            <Route path="/about" element={<AboutUs language={localStorage.getItem('lang')} />} />
            <Route path="/contact" element={<ContactUs language={localStorage.getItem('lang')} />} />

            {/* Protected routes */}
            <Route path="/cart" element={
              <ProtectedRoute><CartScreen language={localStorage.getItem('lang')} /></ProtectedRoute>
            } />
            <Route path="/checkout" element={
              <ProtectedRoute><CheckoutScreen language={localStorage.getItem('lang')} /></ProtectedRoute>
            } />
            <Route path="/orders" element={
              <ProtectedRoute><OrderListScreen language={localStorage.getItem('lang')} /></ProtectedRoute>
            } />

            <Route 
  path="/profile" 
  element={
    <ProtectedRoute>
      <UserProfile />
    </ProtectedRoute>
  } 
/>
            <Route path="/supa" element={
              <AuthProvider>
                <AdminApp />
              </AuthProvider>
            } />
          </Routes>
        </Container>
      </Box>
    </Router>
  );
}

export default App;